import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import Helmet from 'react-helmet'
import dispatchSelector, {
  onApprovedSubmit
} from '../../redux/modules/contact/dispatchers'
import SUBJECT_OPTIONS from './constants'
import CaptchaStandalone from '../CaptchaStandalone/_lazy'
import { CaptchaNotice } from '../generic/CaptchaNotice'
import { recaptchaSelector } from '../../redux/modules/app/selectors'
import '../generic/RenderedField/styles.css'
import './styles.css'

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export function Contact({ verifyRecaptcha, recaptcha }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors }
  } = useForm({
    defaultValues: { subject: 'unselected' }
  })

  const onSubmit = data => {
    verifyRecaptcha(
      { ...data, recaptcha },
      onApprovedSubmit,
      reset
    )
  }

  return (
    <div id="ContactUs">
      <Helmet>
        <title>Contact Us | Stan Winston School of Character Arts</title>
      </Helmet>
      <h1>Contact Us</h1>
      <p>Please contact us with any of your questions, suggestions or other needs.</p>
      <p><b>Customer Care Hours:</b><br />Monday - Friday 9:30 am to 5:30 pm PT</p>
      <p>We strive to respond to all communication within 24 hours, excluding weekends and certain holidays. Also, you can reach us at <a href="mailto:info@stanwinstonschool.com">info@stanwinstonschool.com</a><br />
      - SWSCA Customer Care Team</p>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <div className={classnames('field', '-floating', { '-error': errors.name })}>
            <div className="field-container">
              <input
                {...register('name', { required: 'This field is required.' })}
                type="text"
                placeholder=" "
                id="contact-name"
              />
              <label htmlFor="contact-name">Full Name</label>
              <span
                className={`field__error${!errors.name ? ' field__error--hidden' : ''}`}
                role="alert"
              >
                {errors.name?.message}
              </span>
            </div>
          </div>
          <div className={classnames('field', '-floating', { '-error': errors.email })}>
            <div className="field-container">
              <input
                {...register('email', {
                  required: 'This field is required.',
                  pattern: {
                    value: EMAIL_PATTERN,
                    message: 'Invalid email address.'
                  }
                })}
                type="text"
                placeholder=" "
                id="contact-email"
              />
              <label htmlFor="contact-email">Email</label>
              <span
                className={`field__error${!errors.email ? ' field__error--hidden' : ''}`}
                role="alert"
              >
                {errors.email?.message}
              </span>
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className={classnames('field', { '-error': errors.subject })}>
            <div className="field-container">
              <select
                {...register('subject', {
                  validate: value => value !== 'unselected' || 'This field is required.'
                })}
                aria-label="Subject"
              >
                <option value="unselected" disabled>Subject</option>
                {SUBJECT_OPTIONS.map((option, optionIndex) => (
                  <option key={optionIndex} value={option.value}>{option.name}</option>
                ))}
              </select>
              <span
                className={`field__error${!errors.subject ? ' field__error--hidden' : ''}`}
                role="alert"
              >
                {errors.subject?.message}
              </span>
            </div>
          </div>
          <div className="field -floating">
            <div className="field-container">
              <input
                {...register('order_number')}
                type="text"
                placeholder=" "
                id="contact-order-number"
              />
              <label htmlFor="contact-order-number">Order # (optional)</label>
            </div>
          </div>
        </div>
        <div className={classnames('field', { '-error': errors.message })}>
          <div className="field-container">
            <textarea
              {...register('message', { required: 'This field is required.' })}
              placeholder="Comment"
              aria-label="Comment"
            />
            <span
              className={`field__error${!errors.message ? ' field__error--hidden' : ''}`}
              role="alert"
            >
              {errors.message?.message}
            </span>
          </div>
        </div>
        <CaptchaStandalone />
        <CaptchaNotice />
        <div className="submit-button">
          <button type="submit" disabled={isSubmitting}>Send message</button>
        </div>
      </form>
    </div>
  )
}

Contact.propTypes = {
  verifyRecaptcha: PropTypes.func.isRequired,
  recaptcha: PropTypes.shape({
    token: PropTypes.string,
    version: PropTypes.string
  })
}

export default connect(
  state => ({
    recaptcha: recaptchaSelector(state)
  }),
  dispatchSelector
)(Contact)
